module.exports = __webpack_public_path__ + "img/暴雨.d831bcd1.png";